import Rate from './views/Rate'

const route = [
  {
    path: '/mes-tarifs',
    name: 'rate',
    component: Rate,
    meta: {
      layout: 'default',
      auth: true,
      menu: true,
      title: 'Mes tarifs',
      lang_code: 'my_rates',
      role: ['A','R','C','I'],
      customer_required: true,
      order: 6
    },
    props: true
  }
]

export default route